<div
  class="d-flex flex-lg-row flex-column align-items-center justify-content-lg-center vh-100"
>
  <img
    class="mx-5"
    [src]="environment.serverFolder + 'assets/svg/fit-factory-logo.svg'"
    height="250"
    width="250"
    alt="fit factory logo"
  />

  <div class="card col-10 col-lg-5">
    <div class="card-body">
      <h5 class="card-title">
        Formulario Inicio de sesión
        <span *ngIf="isTablet">| <strong>TABLET GYM</strong></span>
      </h5>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-floating mb-3">
          <input
            class="form-control"
            type="email"
            [ngClass]="{ 'is-invalid': email.invalid && email.touched }"
            placeholder="Email"
            formControlName="email"
          />

          <label for="">Email</label>

          <div *ngIf="email.invalid && email.touched" class="text-danger">
            Ingrese un email válido
          </div>
        </div>

        <div class="input-group">
          <div class="input-group-text mb-3" (click)="changePasswordType()">
            <img
              [src]="environment.serverFolder + '/assets/svg/password-show.svg'"
              fill="none"
              type=""
              *ngIf="isPasswordType"
            />
            <img
              src="environment.serverFolder + 'assets/svg/password-hide.svg'"
              fill="none"
              type=""
              *ngIf="!isPasswordType"
            />
          </div>
          <div class="form-floating mb-3">
            <input
              class="form-control"
              [type]="passwordType"
              [ngClass]="{ 'is-invalid': password.invalid && password.touched }"
              placeholder="Contraseña"
              formControlName="password"
            />

            <label for="">Contraseña</label>
          </div>
        </div>
        <div *ngIf="password.invalid && password.touched" class="text-danger">
          Ingrese una contraseña valida(más de 6 caracteres)
        </div>

        <p *ngIf="credencialesInvalidas" class="text-danger">
          Credenciales Invalidas
        </p>

        <button
          [disabled]="loginForm.invalid"
          class="col-12 col-lg-4 mt-3 d-grid btn-custom"
        >
          Iniciar Sesión
        </button>

        <button
          class="col-12 col-lg-4 mt-3 d-grid btn-custom-outline"
          routerLink="/login-tablet"
          *ngIf="!isTablet"
        >
          Cambiar a modo tablet
        </button>

        <button
          class="col-12 col-lg-4 mt-3 d-grid btn-custom-outline"
          routerLink="/login"
          *ngIf="isTablet"
        >
          Cambiar a modo web
        </button>
      </form>
    </div>
  </div>
</div>
